import { signUp, resendSignUpCode, confirmSignUp } from "aws-amplify/auth";
import { loginActions } from "./";
import { loaderActions } from "../index";
import { LoaderContent } from "../../../../Utils/Loader";

export const signup = (nickname, email, password) => async (dispatch) => {
    await signUp({
        username: email,
        password,
        options: { userAttributes: { email, nickname } },
    });
    dispatch(loginActions.setUserNickname(nickname));
    return dispatch(loginActions.setUserEmail(email));
};

export const resendOTP = (email) => async () => {
    await resendSignUpCode({ username: email });
};

export const signupConfirm = (email, otp) => async (dispatch) => {
    try {
        dispatch(loaderActions.startAppLoader(LoaderContent.LOGIN));
        await confirmSignUp({ username: email, confirmationCode: otp });
        return dispatch(loaderActions.stopAppLoader());
    } catch (e) {
        dispatch(loaderActions.stopAppLoader());
        throw e;
    }
};
